import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CModal, CModalBody, CButton } from '@coreui/react-pro';
import { cilX, cilDelete } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';

import { SYSTEM_ADMIN_PATH } from '../../../constants';
import { setShow } from '../../../actions/general';

const WarningRemainingSeatsPopup = ({ productId }) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();

     const handleCancelButtonClick = () => {
          dispatch(setShow(null));
     };

     const handleGoToRelatedObject = () => {
          dispatch(setShow(null));

          if (productId) {
               navigate(SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_DETAIL.replace(':id', productId));
          } else {
               navigate(SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_DETAIL.replace(':id/', ''));
          }
     };

     return (
          <CModal visible={true} alignment="center" className="remove-popup">
               <CModalBody className="text-center">
                    <CIcon icon={cilX} className="icon-close-popup" onClick={handleCancelButtonClick} />
                    <div className="remove-popup-icon">
                         <CIcon icon={cilDelete} className="text-danger" height={35} alt="CoreUI Icons Delete" />
                    </div>
                    <div className="mb-3">
                         <h5>The number of seats is at its maximum.</h5>
                         <p>Please add additional seats to complete the operation.</p>
                    </div>
                    <CButton className="mb-3" onClick={handleGoToRelatedObject}>
                         Go To Product
                    </CButton>
               </CModalBody>
          </CModal>
     );
};

WarningRemainingSeatsPopup.propTypes = {
     productId: PropTypes.string,
};

export default WarningRemainingSeatsPopup;
